import React from "react";
import { ArrowRight } from "lucide-react";
import { flatlayImage, customPriceCards, audienceTags } from "../mock";

export default function CustomApparelSection() {
  return (
    <section id="custom" className="bg-[color:var(--dms-navy)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="kicker">Custom Apparel</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white mt-4 leading-tight">Apparel that carries your name</h2>
          <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-5" />
          <p className="mt-6 text-white/70 leading-relaxed">
            Create apparel that represents your business, church, ministry, team, organization, event or group. Bring us a logo, a slogan or a rough idea on a napkin — we'll take it from there and show you a proof before a single shirt is printed.
          </p>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {customPriceCards.map((c) => (
              <div key={c.title} className="rounded-xl bg-white/5 border border-white/10 p-4 text-center">
                <p className="font-serif text-white text-[15px]">{c.title}</p>
                <p className="text-[color:var(--dms-peach)] text-xs mt-1 tracking-wider">{c.from}</p>
              </div>
            ))}
          </div>

          <p className="mt-6 text-white/60 text-sm">Long sleeves, caps and other garments available on request.</p>

          <div className="mt-6 flex flex-wrap gap-2">
            {audienceTags.map((t) => (
              <span key={t} className="px-3 py-1 rounded-full border border-white/20 text-white/85 text-xs">{t}</span>
            ))}
          </div>

          <div className="mt-8">
            <a href="#custom" className="btn-peach">Start your custom order <ArrowRight className="w-4 h-4" /></a>
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden">
          <img src={flatlayImage} alt="Flat lay of blank apparel" className="w-full h-[560px] object-cover" />
        </div>
      </div>
    </section>
  );
}
